import { Model } from "@nozbe/watermelondb";
import { field, readonly, date, relation } from "@nozbe/watermelondb/decorators";

export default class OrderLineStatusUpdate extends Model {
  static table = "order_line_status_updates";

  static associations = {
    order_lines: { type: "belongs_to", key: "order_line_id" },
  };

  @field("status") status;
  @field("terminal_id") terminal_id;
  @field("user_id") user_id;
  @readonly @date("created_at") created_at;

  @relation("order_lines", "order_line_id") order_line;
}
